import React, { useEffect, useState } from "react";
import { Button, Col, Row, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import inventoryApi from "../api/inventoryApi";
import moment from "moment";

import {
    DatatableWrapper,
    Filter,
    Pagination,
    PaginationOptions,
    TableBody,
    TableHeader,
} from "react-bs-datatable";
import { Link } from "react-router-dom";
import ReportMonthFilterBar from "./ReportMonthFilterBar"; // Added By Jaseem => CBR Reports Filter Month Wise (27-04-2026)

const HomeBasedCbrList = () => {
    const navigate = useNavigate();
    const now = new Date(); // Added By Jaseem => CBR Reports Filter Month Wise (27-04-2026)
    const [body, setBody] = useState([]);
    const [useMonthFilter, setUseMonthFilter] = useState(true); // Added By Jaseem => CBR Reports Filter Month Wise (27-04-2026)
    const [filterYear, setFilterYear] = useState(now.getFullYear()); // Added By Jaseem => CBR Reports Filter Month Wise (27-04-2026)
    const [filterMonth, setFilterMonth] = useState(now.getMonth() + 1); // Added By Jaseem => CBR Reports Filter Month Wise (27-04-2026)

    useEffect(() => {
        async function init() {
            // Added By Jaseem => CBR Reports Filter Month Wise (27-04-2026)
            const result = useMonthFilter
                ? await inventoryApi.fetchHomeBasedCbrRecs(filterYear, filterMonth)
                : await inventoryApi.fetchHomeBasedCbrRecs();
            setBody(Array.isArray(result) ? result : []);
        }
        init();
    }, [useMonthFilter, filterYear, filterMonth]); // Added By Jaseem => CBR Reports Filter Month Wise (27-04-2026)

    const header = [
        {
            title: "Child Name",
            prop: "name",
            childname: true,
            isFilterable: true,
            cell: (row) => (
                <Link to={"/homebasedcbr/" + row.id + `/e`} state={row}>
                    {row.name}
                </Link>
            ),
        },
        { title: "Service Area", prop: "servicearea", isFilterable: true },
        // { title: 'Child Name', prop: 'childname', childname: true },
        { title: "Cbr Worker Name", prop: "cbrworker", isFilterable: true },
        { title: "Date", prop: "date", isFilterable: true, cell: (row) => moment(row.date).format('MM/DD/YYYY'),}, // Added By Jaseem => CBR Reports Filter Month Wise (27-04-2026)
    ];

    const labels = {
        beforeSelect: "",
    };

    const createHomeBasedCbr = () => {
        navigate(`/homebasedcbr/e`);
    };

    return (
        <Row className="g-0">
            <Col lg={2} className="mx-2">
                <Link className="nav-link">
                    Home <i class="fa-solid fa-chevron-right"></i> Home Based Format
                </Link>
            </Col>
            <Col lg={12} className="p-lg-4">
            {/* // Added By Jaseem => CBR Reports Filter Month Wise (27-04-2026)*/}
                <ReportMonthFilterBar
                    useMonthFilter={useMonthFilter}
                    onUseMonthFilterChange={setUseMonthFilter}
                    year={filterYear}
                    month={filterMonth}
                    onYearChange={setFilterYear}
                    onMonthChange={setFilterMonth}
                />
                {body ? (
                    <DatatableWrapper
                        body={body}
                        headers={header}
                        paginationOptionsProps={{
                            initialState: {
                                rowsPerPage: 50,
                                options: [5, 10, 15, 20],
                            },
                        }}
                    >
                        <Row className="mb-4">
                            <Col
                                xs={12}
                                lg={4}
                                className="d-flex flex-col justify-content-end align-items-end"
                            >
                                <Filter />
                            </Col>
                            <Col
                                xs={12}
                                sm={6}
                                lg={4}
                                className="d-flex flex-col justify-content-start align-items-start"
                            >
                                <PaginationOptions labels={labels} />
                            </Col>
                            <Col
                                xs={12}
                                sm={6}
                                lg={4}
                                className="d-flex flex-col justify-content-end align-items-end"
                            >
                                <Button
                                    className="btn-sm"
                                    variant="outline-primary"
                                    onClick={() => createHomeBasedCbr(true)}
                                >
                                    Create Home Based CBR
                                </Button>
                            </Col>
                        </Row>
                        <Table striped className="data-table">
                            <TableHeader />
                            <TableBody />
                        </Table>
                        <Pagination />
                    </DatatableWrapper>
                ) : (
                    ""
                )}
            </Col>
            <Col lg={2}></Col>
        </Row>
    );
};

export default HomeBasedCbrList;
